import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './index.css';
import { useTheme } from "../../../../ui/src/contextProviders"
import { customStyle } from '@custom/Utils/utils';

const stickyClasses = 'sticky top-0';
const notStickyClasses = 'relative';

const NavBar = ({ className, children, isSticky }) => {
  const { isDarkMode } = useTheme();
  return (
    <div
      className={classnames(
        'bg-secondary-dark z-20 w-16 border-black px-1 sideNavBarItems',
        isSticky && stickyClasses,
        !isSticky && notStickyClasses,
        className
      )}
      style={
        isDarkMode ? { background: '#090c29' } : { background: '#75b1b1' }
      }
    >
      {children}
    </div>
  );
};

NavBar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  isSticky: PropTypes.bool,
};

export default NavBar;
